// View
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Yup & Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injections
import { AccountsInjection } from '../../containers/accountsInjection';

// View
import { AccountsFormPage } from './view';

export const AccountsForm = () => {
  const { accountById, updateAccounts, createAccounts, getAccountById } =
    AccountsInjection();

  const { id } = useParams();
  const history = useHistory();

  let typeOptions = [
    { value: '1', label: 'Conta corrente' },
    { value: '2', label: 'Espécie' },
    { value: '3', label: 'Outros' },
  ];

  const getTypeName = (typeId) => {
    const type = typeOptions.find((item) => item.value === typeId);
    return type.label;
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      typeAccount: accountById
        ? {
            value: accountById.type,
            label: getTypeName(accountById.type),
          }
        : null,
      name: accountById ? accountById.name : '',

      balance: accountById ? accountById.opening_balance : '',

      dataInitialBalance: accountById
        ? accountById.start_date.split('/').reverse().join('-')
        : '',
    },

    validationSchema: Yup.object({
      typeAccount: Yup.object().nullable().required('Informe o tipo da conta'),
      name: Yup.string().required('Informe o nome da conta'),
      balance: Yup.number(),
      dataInitialBalance: Yup.date(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        type: values.typeAccount.value,
        name: values.name,
        opening_balance: values.balance,
        start_date: values.dataInitialBalance,
      };

      if (accountById) {
        updateAccounts(accountById.id, valuesToSubmit, history);
      } else {
        createAccounts(valuesToSubmit, history);
      }
    },
  });

  const getAccounts = async (id) => {
    if (id) {
      await getAccountById(id);
    }
  };

  useEffect(() => {
    getAccounts(id);
  }, [id]);

  return (
    <AccountsFormPage
      loading={false}
      history={history}
      validation={validation}
      typeOptions={typeOptions}
      accountById={accountById}
    />
  );
};
